// import parseTime, formatTime and set to filter
export {parseTime, formatTime} from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
	if (time === 1) {
		return time + label
	}
	return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
	const between = Date.now() / 1000 - Number(time)
	if (between < 3600) {
		return pluralize(~~(between / 60), ' minute')
	} else if (between < 86400) {
		return pluralize(~~(between / 3600), ' hour')
	} else {
		return pluralize(~~(between / 86400), ' day')
	}
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
	const si = [
		{value: 1E18, symbol: 'E'},
		{value: 1E15, symbol: 'P'},
		{value: 1E12, symbol: 'T'},
		{value: 1E9, symbol: 'G'},
		{value: 1E6, symbol: 'M'},
		{value: 1E3, symbol: 'k'}
	]
	for (let i = 0; i < si.length; i++) {
		if (num >= si[i].value) {
			return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
		}
	}
	return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
	return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export function emptyText(string) {
	return string || '-'
}


// 金额保留两位小数
export function moneyFormat(num) {
	// 判断给定的数是否为数字
	if (typeof num == "number" && !isNaN(num)) {
		return num.toFixed(2);
	} else {
		return num;
	}

}

/**
 * 自定义表头列表项显示
 * @param row
 * @param header
 * @param defaultVal
 */
export function customHeaderItem(row, header, defaultVal = '-', errVal='未知') {
	let result = row[header.name]
	const dict = header.dict
	if (dict) {
		return dict[result] ?? errVal
	} else {
		return result ?? defaultVal
	}
}
export function formatTimestamp(timestamp, format = 'YYYY-MM-DD hh:mm:ss') {
  if(!timestamp) return
  // 如果时间戳是秒，转换为毫秒
  const ts = String(timestamp).length === 10 ? timestamp * 1000 : timestamp
  const date = new Date(ts)
  
  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    console.error('无效的时间戳:', timestamp)
    return ''
  }
  
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('hh', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}
/**
 * 时间戳转换为 YYYY-MM-DD 格式
 * @param {number|string} timestamp - 时间戳（毫秒或秒）
 * @returns {string} 格式化后的日期字符串
 */
export function timestampToDate(timestamp) {
  return formatTimestamp(timestamp, 'YYYY-MM-DD')
}
